export default __webpack_public_path__ + "static/media/calendar.633a32a5.svg";